import { arrayFrom, cssEscape } from '@datadog/browser-core';
export function getSelectorFromElement(targetElement) {
    var targetElementSelector = [];
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var idSelector = getIDSelector(element);
        if (idSelector) {
            targetElementSelector.unshift(idSelector);
            break;
        }
        targetElementSelector.unshift(getClassSelector(element) || getPositionSelector(element));
        element = element.parentElement;
    }
    return targetElementSelector.join('>');
}
function getIDSelector(element) {
    if (!element.id)
        return;
    var escapedId = cssEscape(element.id);
    var isUnique = element.ownerDocument.body.querySelectorAll("#".concat(escapedId)).length === 1;
    if (isUnique)
        return "#".concat(escapedId);
}
function getClassSelector(element) {
    var orderedClassList = arrayFrom(element.classList).sort();
    var classUniqueAmongSiblings = true;
    for (var i = 0; i < element.parentElement.children.length; i++) {
        var sibling = element.parentElement.children[i];
        if (sibling === element)
            continue;
        if (sibling.tagName === element.tagName && sameClasses(orderedClassList, sibling.classList)) {
            classUniqueAmongSiblings = false;
            break;
        }
    }
    if (classUniqueAmongSiblings)
        return "".concat(element.tagName).concat(orderedClassList.map(function (className) { return ".".concat(cssEscape(className)); }).join(''));
}
function sameClasses(a, b) {
    return a.length <= b.length && a.every(function (className) { return b.contains(className); });
}
function getPositionSelector(element) {
    var isUniqueChild = !element.previousElementSibling && !element.nextElementSibling;
    if (isUniqueChild)
        return "".concat(element.tagName);
    var index = 1;
    var prevSibling = element.previousElementSibling;
    while (prevSibling) {
        if (element.tagName === prevSibling.tagName)
            index++;
        prevSibling = prevSibling.previousElementSibling;
    }
    return "".concat(element.tagName, ":nth-of-type(").concat(index, ")");
}
